import api from "./axios";

const EndPoints = {
  twofa: "/merchant/settings/security/2fa",
  addTwoFA: "/merchant/settings/security/2fa",
  changePassword: "/merchant/settings/security/password",
  updateGeneralSettings: `/merchant/settings/business`,
  paymentConfig: `/merchant/settings/business/treasura/keys`,
  generalSettings: `/merchant/settings/business`,
  discount: `/merchant/settings/business/discount`,
  changeEnv: `/merchant/settings/api`,
  join(token: string) {
    return `/merchant/settings/team/${token}/accept`;
  },
  suspend(id: string) {
    return `/merchant/settings/team/${id}/suspend`;
  },
  role(id: string) {
    return `/merchant/settings/team/${id}/change-role`;
  },
  unsuspend(id: string) {
    return `/merchant/settings/team/${id}/unsuspend`;
  },
  add: `/merchant/settings/team/invite`,
  sendNotification: `/merchant/notification/communication/messages`,
  announcements(page: number) {
    return `/merchant/announcement?order=DESC&page=${page}&take=10`;
  },
  announcement(id: string) {
    return `/merchant/announcement/${id}`;
  },
  addAnnouncement: `/merchant/announcement`,
  notice: `/notice`,
  getTeams(
    page: number,
    filter: {
      to: string;
      from: string;
      status: string;
    }
  ) {
    let query = `/merchant/settings/team?order=DESC&page=${page}&take=10`;
    if (filter?.to) {
      query += `&to=${filter?.to}`;
    }
    if (filter?.from) {
      query += `&from=${filter?.from}`;
    }
    if (filter?.status) {
      query += `&status=${filter?.status}`;
    }
    return query;
  },
  getNotifications(
    page: number,
    filter: {
      to: string;
      from: string;
    }
  ) {
    let query = `/merchant/notification/communication/messages?order=DESC&page=${page}&take=10`;
    if (filter?.to) {
      query += `&to=${filter?.to}`;
    }
    if (filter?.from) {
      query += `&from=${filter?.from}`;
    }

    return query;
  },
  notification(page: number, id: string) {
    return `/merchant/notification/communication/messages?customerId=${id}&order=DESC&page=${page}&take=10`;
  },
  referral: `/merchant/referral/setting`,
  limit: `/merchant/currency/update-limit`,
};

export const getTwoFa = async () => {
  const res = await api.get(EndPoints.twofa);
  return res;
};
export const AddTwoFA = async (payload: unknown) => {
  const res = await api.post(EndPoints.addTwoFA, payload);
  return res;
};
export const ChangeInAppPassword = async (payload: unknown) => {
  const res = await api.post(EndPoints.changePassword, payload);
  return res;
};
export const generalSetting = async (payload: unknown) => {
  const res = await api.patch(EndPoints.updateGeneralSettings, payload);
  return res;
};
export const paymentConfig = async (payload: unknown) => {
  const res = await api.patch(EndPoints.paymentConfig, payload);
  return res;
};
export const transactionDiscount = async (payload: unknown) => {
  const res = await api.patch(EndPoints.discount, payload);
  return res;
};
export const getTransactionDiscount = async () => {
  const res = await api.get(EndPoints.discount);
  return res;
};
export const getGeneralSetting = async () => {
  const res = await api.get(EndPoints.generalSettings);
  return res;
};
export const getMerchantTeams = async (
  page: number,
  filter: {
    to: string;
    from: string;
    status: string;
  }
) => {
  const res = await api.get(EndPoints.getTeams(page, filter));
  return res;
};
export const ChangeEnv = async (payload: unknown) => {
  const res = await api.post(EndPoints.changeEnv, payload);
  return res;
};
export const joinViaInvite = async (token: string) => {
  const res = await api.post(EndPoints.join(token));
  return res;
};
export const suspendTeamMember = async (id: string) => {
  const res = await api.patch(EndPoints.suspend(id));
  return res;
};
export const changeRole = async (id: string, payload: unknown) => {
  const res = await api.post(EndPoints.role(id), payload);
  return res;
};
export const unsuspendTeamMember = async (id: string) => {
  const res = await api.patch(EndPoints.unsuspend(id));
  return res;
};
export const addSomeone = async (payload: unknown) => {
  const res = await api.post(EndPoints.add, payload);
  return res;
};
export const sendNotification = async (payload: unknown) => {
  const res = await api.post(EndPoints.sendNotification, payload);
  return res;
};
export const getAllNotifications = async (
  page: number,
  filter: {
    to: string;
    from: string;
  }
) => {
  const res = await api.get(EndPoints.getNotifications(page, filter));
  return res;
};
export const getSingleNotifications = async (page: number, id: string) => {
  const res = await api.get(EndPoints.notification(page, id));
  return res;
};
export const getAnnouncements = async (page: number) => {
  const res = await api.get(EndPoints.announcements(page));
  return res;
};
export const getAnnouncement = async (id: string) => {
  const res = await api.get(EndPoints.announcement(id));
  return res;
};
export const getNotice = async () => {
  const res = await api.get(EndPoints.notice);
  return res;
};
export const editNotice = async (payload: unknown) => {
  const res = await api.post(EndPoints.notice, payload);
  return res;
};
export const getTransactionReferral = async () => {
  const res = await api.get(EndPoints.referral);
  return res;
};

export const postAnnouncement = async (payload: unknown) => {
  const res = await api.post(EndPoints.addAnnouncement, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
      "x-app-version": 1,
    },
  });
  return res;
};
export const PostReferral = async (payload: unknown) => {
  const res = await api.post(EndPoints.referral, payload);
  return res;
};
export const updateLimit = async (payload: unknown) => {
  const res = await api.post(EndPoints.limit, payload);
  return res;
};
